import React, {useState} from "react";
import { Column, Columns } from "@allxsmith/bestax-bulma";
import CourtesyCars from "./CourtesyCars";
import SalesPrepVehicles from "./SalesPrepVehicles";
import {useDepartmentsData} from "../../hooks/useDepartmentsData";
import {useSelector} from "react-redux";
import {getDepartmentsData, getVehiclesData} from "../../state/selectors";
import LoadingSpinner from "../Utils/Spinner";
import {useVehiclesData} from "../../hooks/useVehiclesData";


export default function VehicleSection({endpoint, dataFresh}){
    let params = {view: "HOME", page_size: 1000}
    const [filters, setFilters] = useState({});
    for (let filter in filters) {
        if (filters[filter][0] && filters[filter][0][filter]) {
            params[filter] = filters[filter][0][filter];
        }
    }
    const vehiclesLoaded = useVehiclesData(params, dataFresh);
    const vehicleData = useSelector(getVehiclesData);


    if (!vehiclesLoaded){
        return <LoadingSpinner/>
    }




    return (
        <div>
            <Columns isMultiline>
                <Column>
                  <CourtesyCars endpoint={endpoint} data={vehicleData} setFilters={setFilters} filters={filters} dataFresh={dataFresh}/>
                </Column>
              </Columns>
            <Columns isMultiline>
              <Column>
                <SalesPrepVehicles endpoint={endpoint} data={vehicleData} setFilters={setFilters} filters={filters} dataFresh={dataFresh}/>
              </Column>
          </Columns>
        </div>
    );




}